import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BadgeComponent } from '@go-modules/components/badge/badge.component';

@NgModule({
	declarations: [
		BadgeComponent
	],
	imports: [
		CommonModule,
		TranslateModule
	],
	exports: [
		BadgeComponent
	]
})
export class BadgeModule {}
